/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If this component does not
 * do what you need it to, please reach out to a frontend
 * engineer before creating a new component or making
 * unapproved changes to this file.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import styles from './table.scss';

export type TableDataPropTypes = React.BaseHTMLAttributes<HTMLTableCellElement> & {
  tag?: 'th' | 'td',
};

function TableData({
  tag: Tag = 'td',
  className = '',
  children,
  ...props
}: TableDataPropTypes) {
  return (
    <Tag
      data-qa-ref="table-data"
      className={classnames(styles.tableData, className)}
      {...props}
    >
      {children}
    </Tag>
  );
}

export default TableData;
